var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import { arrow, autoUpdate, flip, FloatingPortal, offset, shift, useFloating, } from '@floating-ui/react';
import cx from 'classnames';
import { Typography } from '../../../foundations/typography';
import tooltipStyles from '../Tooltip.module.scss';
function makePositionStyle(value, positionName) {
    if (value === undefined) {
        return undefined;
    }
    return "calc(".concat(value, "px + var(--wtr-tooltip-arrow-").concat(positionName, ", 0px))");
}
var BubbleComponent = function (_a) {
    var _b, _c;
    var className = _a.className, content = _a.content, referenceElement = _a.referenceElement, placement = _a.placement, skiddingOffset = _a.skiddingOffset, distanceOffset = _a.distanceOffset, isOpen = _a.isOpen, props = __rest(_a, ["className", "content", "referenceElement", "placement", "skiddingOffset", "distanceOffset", "isOpen"]);
    var arrowRef = useRef(null);
    var _d = useFloating({
        open: isOpen,
        middleware: [
            offset({ mainAxis: distanceOffset, crossAxis: skiddingOffset }, [
                distanceOffset,
                skiddingOffset,
            ]),
            flip(),
            shift(),
            arrow({ element: arrowRef, padding: 8 }),
        ],
        whileElementsMounted: autoUpdate,
        elements: { reference: referenceElement },
        placement: placement,
    }), refs = _d.refs, floatingStyles = _d.floatingStyles, actualPlacement = _d.placement, middlewareData = _d.middlewareData;
    if (!isOpen) {
        return null;
    }
    return (React.createElement(FloatingPortal, null,
        React.createElement("div", __assign({}, props, { ref: refs.setFloating, style: floatingStyles, className: cx(className, tooltipStyles.tooltip), role: "tooltip", "data-tooltip-placement": actualPlacement }),
            typeof content === 'string' ? (React.createElement(Typography, { styleAs: "paragraphSmall", element: "span" }, content)) : (content),
            React.createElement("div", { ref: arrowRef, className: tooltipStyles.triangle, style: {
                    top: makePositionStyle((_b = middlewareData.arrow) === null || _b === void 0 ? void 0 : _b.y, 'top'),
                    left: makePositionStyle((_c = middlewareData.arrow) === null || _c === void 0 ? void 0 : _c.x, 'left'),
                } }))));
};
export var Bubble = React.memo(BubbleComponent);
//# sourceMappingURL=Bubble.js.map